import React, { useContext, useState } from 'react';
import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Tooltip
} from '@material-ui/core';
import usePagination from './utils/usePagination';
import { Pagination } from '@material-ui/lab';
import { InfoOutlined } from '@material-ui/icons';
import StatusColorDisplay from '../../../../core/components/StatusColorDisplay';
import { CreationFundContext } from '../CreationFundContext';
import ManageAuthorizations from '../../../users/userauthorization/stepper/ManageAuthorizations';

export const ContactsTable = ({
  contacts,
  classes,
  displayTooltip,
  handleManageClick
}) => {
  const PER_PAGE = 25;
  const [page, setPage] = useState(1);
  const _DATA = usePagination(contacts, PER_PAGE);
  const count = Math.ceil(contacts.length / PER_PAGE);

  const handlePaginationChange = (_event, pageSelected) => {
    setPage(pageSelected);
    _DATA.jump(pageSelected);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <div className={classes.tableWrapper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>Contact Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>User ID</TableCell>
                <TableCell>Email Address</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Permission Groups</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {_DATA.currentData().length === 0 && (
                <TableRow>
                  <TableCell>
                    There are no related Contacts to be displayed
                  </TableCell>
                </TableRow>
              )}
              {_DATA.currentData().map(contact => (
                <TableRow key={contact.userId}>
                  <TableCell>{`${contact.firstName} ${contact.lastName}`}</TableCell>
                  <TableCell>
                    <StatusColorDisplay status={contact.status} />
                  </TableCell>
                  <TableCell>{contact.userId}</TableCell>
                  <TableCell>{contact.email}</TableCell>
                  <TableCell>{contact.company}</TableCell>
                  <TableCell className={classes.tableCellWrapper}>
                    <Button
                      classeName={classes.manageButton}
                      size="small"
                      color="primary"
                      variant="text"
                      onClick={() => handleManageClick(contact)}
                    >
                      Manage
                    </Button>
                    {displayTooltip(contact.userId) && (
                      <Tooltip
                        title="Permissions will be saved upon completing this step"
                        arrow
                        placement="top"
                      >
                        <InfoOutlined color={'action'} />
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {count > 1 && (
            <Pagination
              page={page}
              count={count}
              onChange={handlePaginationChange}
              color="primary"
              shape="rounded"
              className={classes.pagination}
            />
          )}
        </div>
      </Grid>
    </Grid>
  );
};

const ContactsList = ({
  contacts,
  classes,
  groups,
  authorizationsConnectedUser,
  connectedUserProfile,
  authorizationsGridToDeleteRef,
  permissionGroupsUploaded,
  setCurrentAuthorizations,
  currentAuthorizations,
  onSubmitEnd,
  hasAssignUserAuthorization,
  ...props
}) => {
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const { fundContext: context } = useContext(CreationFundContext);

  const displayTooltip = contactId => {
    return currentAuthorizations.some(
      authorization => authorization.userId === contactId
    );
  };

  const handleManageClick = contact => {
    setSelectedContact(contact);
    setIsManageModalOpen(true);
  };

  return (
    <>
      <ContactsTable
        contacts={contacts}
        classes={classes}
        displayTooltip={displayTooltip}
        handleManageClick={handleManageClick}
      />
      {selectedContact && (
        <ManageAuthorizations
          contact={selectedContact}
          isManageModalOpen={isManageModalOpen}
          setIsManageModalOpen={setIsManageModalOpen}
          groups={groups}
          connectedUserProfile={connectedUserProfile}
          authorizationsConnectedUser={authorizationsConnectedUser}
          authorizationsGridToDeleteRef={authorizationsGridToDeleteRef}
          permissionGroupsUploaded={permissionGroupsUploaded}
          setCurrentAuthorizations={setCurrentAuthorizations}
          currentAuthorizations={currentAuthorizations}
          onSubmitEnd={onSubmitEnd}
          hasAssignUserAuthorization={hasAssignUserAuthorization}
          context={context}
          {...props}
        />
      )}
    </>
  );
};

export default ContactsList;
